import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const errorsStr = helpers.error.errors
const mapper = helpers.mapper
const apiModule = api.dealers

function getModel () {
  return {

  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  id: null,
  show: 'all',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {},
  find: [],
  findFull: [],
  finded: null
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getShow (state) { return state.show },
  getOne (state) { return state.question },
  getAll (state) { return state.questions },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain },
  getFind (state) { return state.find },
  getFinded (state) { return state.finded },
  getFindDealerIdByName (state) {
    let findFull = state.findFull
    let finded = state.finded
    let f = findFull.find(item => item.NAME == finded)
    return f
  }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.question = data },
  setAll (state, data) { state.questions = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setFind (state, data) { state.find = data },
  setFindFull (state, data) { state.findFull = data },
  setFinded (state, data) { state.finded = data }
}
const actions = {
  setModelRequired ({ commit }, data) {
    // commit('setModel', mapper.modelRequired(data.required, getModel()));
  },
  // resetAllErr({commit}){
  //     // commit('setErrMain', null);
  //     // let errors = state.errors;
  //     // for(let err in errors){
  //     //     commit('setErrors', {param: err, value: null});
  //     // };
  // },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'one')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule.admin.getOne, { id: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(apiModule[role()].getAllStatusMysql, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async runFind ({ state, commit, dispatch }, data) {
    try {
      commit('setFinded', null)
      let result = await httpService.get(apiModule[role()].getByIdName, data.params)
      if (!result && !result.data && !result.data.data) commit('setFind', [])
      let items = result.data.data
      commit('setFindFull', items)
      let find = []
      items.forEach(item => {
        // find.push(`ID: ${item.ID} ИМЯ: ${item.NAME}`)
        find.push(item.NAME)
      })
      commit('setFind', find)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
